
import Vue from 'vue';
import Lottie from '../Lottie.vue';
import * as confettiAnimation from '@/assets/animations/confetti-explosion.json';

export default Vue.extend({
  components: {
    Lottie,
  },
  props: {
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    numberOfConfettis: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    options() {
      return {
        loop: false,
        autoplay: true,
        animationData: confettiAnimation,
      };
    },
  },
});
